
/* injects from baggage-loader */

'use strict';

import ProjectComponent from './project.component';
import './project.scss';

const ProjectPageModule = angular.module('project-module', [
  'ui.router'
])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('project', {
        url: '/project/{id}',
        component: 'project',
        resolve: {
          project: function (Projects, $transition$) {
            return Projects.get($transition$.params('to').id);
          },
          documents: function(project) {
            let query = project.get('documents').query();
            query.ascending("createdAt");
            return query.find(); 
          },
          comments: function (project) {
            let query = project.get('comments').query();
            query.descending("createdAt");
            query.include(['author', 'author.image']);
            query.select(['author.first_name', 'author.last_name', 'author.image', 'text', 'author_tag', 'parent', 'project'])
            return query.find();
          }
        }
      });

  })
  .run(function ($transitions, $state, $rootScope, Errors) {

    // Handle setup on success entering the project page
    $transitions.onSuccess({ to: 'project' }, transition => {

      // Unlock the page header so the project scrollspy can perform
      $rootScope.unlockHeader = true;

    });

    // Handle an error encountered while entering the project page
    $transitions.onError({ to: 'project' }, transition => {

      // Get the error code 
      let code = transition.error().detail.message;

      // Retrieve the error message
      let error = Errors[code];

      // TODO: handle this better by taking the user to an erro page
      // Display the error message
      if (typeof error !== 'undefined') {
        alert(error.message);
      }

      // Redirect to handle the error
      if (typeof error !== 'undefined' && typeof error.redirectTo === 'string') {
        $state.go(error.redirectTo);
      } else {
        $state.go('projects');
      }

    });

  })
  .component('project', new ProjectComponent());

export default ProjectPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/project/project.module.js